<template lang="pug">
  .box
    .banner
      <swiper ref="mySwiper" :options="swiperOptions">
        <swiper-slide>
          img(src="../assets/img/product/banner2.jpg" alt="")
        </swiper-slide>
        <swiper-slide>
          a(href="https://h5.dingtalk.com/open-market/share.html?shareGoodsCode=7071618BD6F5CEFB677FCF62A6AD62227846CB3F919B9D4B270D1637EA80DF2F7031ED9CC96F7FA2&token=f66e5b1c91488fb581d980011246231d&shareUid=CFE7AA3079B585B6608BAD1C2A09D307#/" target="_blank")
            img(src="../assets/img/product/banner3.jpg" alt="")
        </swiper-slide>
        <swiper-slide>
          a(href="https://h5.dingtalk.com/open-market/share.html?shareGoodsCode=7071618BD6F5CEFB677FCF62A6AD622250BA776A48A9B5EB797304F68A614A6DC309B52E2819FE7B&token=67c503ad4d57c5072da78394c50dc9e0&shareUid=CFE7AA3079B585B6608BAD1C2A09D307#/" target="_blank")
            img(src="../assets/img/product/banner4.jpg" alt="")
        </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      .gai
        ul
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==1?'bc':'']" @click="one") 速云平台
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==2?'bc':'']" @click="two") 速云食堂
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==3?'bc':'']" @click="three") 速云学院
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==4?'bc':'']" @click="four") 速云门户
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==5?'bc':'']" @click="five") 速云公文
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==6?'bc':'']" @click="six") 速云党建
      .gai1(v-if="flag3==true")
        ul
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==1?'bc':'']" @click="one") 速云平台
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==2?'bc':'']" @click="two") 速云食堂
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==3?'bc':'']" @click="three") 速云学院
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==4?'bc':'']" @click="four") 速云门户
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==5?'bc':'']" @click="five") 速云公文
          li
            a(href="javascript:;" :class="[this.$store.state.flag1==6?'bc':'']" @click="six") 速云党建
    .productBox
      .productBody
        <router-view></router-view>
</template>

<script>
export default {
  data () {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        slidesPerView: 1,
        loop: true,
        centeredSlides: true
      },
      flag3: false,
      scrollTop: 0
    }
  },
  created () {
    this.$store.commit('changeNav', 2)
  },
  methods: {
    one () {
      this.flag = 1
      this.$router.push('/platform')
    },
    two () {
      this.flag = 2
      this.$router.push('/canteen')
    },
    three () {
      this.flag = 3
      this.$router.push('/college')
    },
    four () {
      this.flag = 4
      this.$router.push('/vote')
    },
    five () {
      this.flag = 5
      this.$router.push('/document')
    },
    six () {
      this.flag = 6
      this.$router.push('/partybuilding')
    },
    handleScroll () {
      // console.log(window.pageYOffset)
      // this.scrollTop = window.pageYOffset
      // if (window.pageYOffset >= 480) {
      //   this.flag1 = true
      // }
      // if (window.pageYOffset >= 960) {
      //   console.log('di1')
      //   this.flag2 = true
      // }
      // if (window.pageYOffset >= 1440) {
      //   console.log('di2')
      //   this.flag3 = true
      // }
      // if (window.pageYOffset >= 1920) {
      //   console.log('di3')
      //   this.flag4 = true
      // }
    },
    // 导航栏的显示隐藏
    handle (e) {
      e = e || window.event
      if (e.wheelDelta) {
        if (e.wheelDelta > 0) {
          this.flag3 = false
        } else if (e.wheelDelta < 0) {
          if (this.scrollTop > 158) {
            this.flag3 = true
          } else {
            this.flag3 = false
          }
        }
      } else if (e.detail) {
        if (e.detail > 0) {
          this.flag3 = false
        } else if (e.detail < 0) {
          if (this.scrollTop > 158) {
            this.flag3 = true
          } else {
            this.flag3 = false
          }
        }
      }
    }
  },
  mounted () {
    document.title = '速云官网'
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('wheel', this.handle)
  }
}
</script>

<style lang="less" scoped>
  .banner{
    width: 100%;
    position: relative;
    img{
      width: 100%;
      vertical-align: middle;
    }
    .gai1,.gai{
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 70px;
      background-color: rgba(0, 0, 0, .3);
      z-index: 99;
      ul{
        width: 70%;
        overflow: hidden;
        margin: 0 auto;
        li{
          float: left;
          width: 16.6%;
          height: 70px;
          line-height: 70px;
          text-align: center;
          a{
            display: block;
            color: #fff;
            font-size: 16px;
          }
          a:hover{
            background-color: rgba(255, 255, 255, .2);
            box-shadow: 1px 1px 4px rgba(255, 255, 255, .5);
          }
        }
      }
    }
    .gai1{
      position: fixed;
      top: 0;
      left: 0;
      z-index: 999;
    }
  }
  .bc{
    background-color: rgba(255, 255, 255, .2);
    box-shadow: 1px 1px 4px rgba(255, 255, 255, .5);
  }
  .productBox{
    width: 100%;
    margin-top: 50px;
    .productNav{
      width: 70%;
      height: 144px;
      margin: 0 auto;
      overflow: hidden;
      ul{
        width: 100%;
        margin: 58px 0;
        li{
          float: left;
          margin-right: 50px;
          cursor: pointer;
          .big{
            float: left;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            background-color: #ccc;
            overflow: hidden;
            margin: 8px 10px 0 0;
            .small{
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color: #007BF9;
              margin: 3px;
            }
          }
          a{
            font-size: 20px;
          }
        }
        li:hover{
          .big{
            visibility: visible;
          }
        }
        .hide{
          .big{
            visibility: hidden;
          }
        }
        .show{
          .big{
            visibility: visible;
          }
        }
      }
    }
  }
</style>
